export default {
  tag: 'Test',
  tag_tooltip: 'Ristorante di test: pienamente funzionante, mai fatturato.',
  card: {
    title: 'Ristorante di test',
    description:
      'Contrassegna un ristorante come ristorante di test per provare stampe, e-mail, ordini e integrazioni in produzione. Funziona come qualsiasi altro ristorante e non viene mai fatturato. Le e-mail e gli SMS ai clienti sui suoi ordini iniziano con [TEST].',
    payments_note:
      'I pagamenti presso il ristorante di test sono reali e vengono liquidati come qualsiasi altro. Rimborsa tu stesso gli ordini di test. Veniamo avvisati quando le sue vendite mensili superano la soglia di test.',
    designated_on: 'Contrassegnato come test il {{date}}',
    open_shop: 'Apri negozio',
    remove: 'Rimuovi designazione Test',
    select_placeholder: 'Scegli un ristorante',
    mark: 'Contrassegna come ristorante di test',
    no_restaurants: 'Non hai ancora nessun ristorante da contrassegnare.',
    load_error: 'Impossibile caricare il tuo ristorante di test.',
  },
  remove_confirm: {
    title: 'Rimuovere la designazione Test da {{name}}?',
    description_live:
      'La fatturazione per questo ristorante riprende e va offline immediatamente. Rilancialo da Impostazioni ordini → Metodi di Ordine → Ordini live, dove scegli il suo piano.',
    description_stays_live:
      'Questo ristorante rimane attivo e da ora in poi viene trattato di nuovo come i tuoi altri ristoranti.',
    description_offline:
      'La fatturazione per questo ristorante riprende una volta che va live. Il piano viene scelto al lancio.',
    confirm: 'Rimuovi designazione Test',
  },
  toasts: {
    designated: '{{name}} è ora il tuo ristorante di test. Non viene fatturato.',
    designate_error: 'Impossibile contrassegnare il ristorante come test. Riprova.',
    removed: '{{name}} non è più il tuo ristorante di test.',
    removed_offline: '{{name}} non è più il tuo ristorante di test ed è ora offline.',
    remove_error: 'Impossibile rimuovere la designazione Test. Riprova.',
  },
};
